// Readable, slimmed copy of the obfuscated Shrine main.js: only the cart, search, product-info and sticky-atc components the shop renders.
const ON_CHANGE_DEBOUNCE_TIMER = 300;
const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change"
};
let subscribers = {};
function subscribe(_0x376b21, _0x20b568) {
  if (subscribers[_0x376b21] === undefined) {
    subscribers[_0x376b21] = [];
  }
  subscribers[_0x376b21] = [...subscribers[_0x376b21], _0x20b568];
  return function _0x33238a() {
    subscribers[_0x376b21] = subscribers[_0x376b21].filter(_0x466cd1 => {
      return _0x466cd1 !== _0x20b568;
    });
  };
}
;
function publish(_0x5e90c7, _0x6858b2) {
  if (subscribers[_0x5e90c7]) {
    subscribers[_0x5e90c7].forEach(_0x260111 => {
      _0x260111(_0x6858b2);
    });
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", _0x4b295f => {
      _0x4b295f.preventDefault();
      const _0x268cd3 = this.closest("cart-items") || this.closest("cart-drawer-items");
      if (this.clearCart) {
        _0x268cd3.clearCart();
      } else {
        _0x268cd3.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
    this.secondCartItems = document.querySelector("cart-drawer-items");
    const _0x54e5ae = debounce(_0x2ccd83 => {
      this.onChange(_0x2ccd83);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener("change", _0x54e5ae.bind(this));
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, _0xd5e831 => {
      if (_0xd5e831.source === "cart-items") {
        return;
      }
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onChange(_0x15473b) {
    this.updateQuantity(_0x15473b.target.dataset.index, _0x15473b.target.value, document.activeElement.getAttribute("name"));
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items").then(_0x2698cc => _0x2698cc.text()).then(_0x34e225 => {
      const _0x4e5a45 = new DOMParser().parseFromString(_0x34e225, "text/html");
      const _0x506976 = _0x4e5a45.querySelector("cart-items");
      this.innerHTML = _0x506976.innerHTML;
    }).catch(_0x50a272 => {
      console.error(_0x50a272);
    });
  }
  updateCart() {
    const _0x52be56 = JSON.stringify({
      sections: this.getSectionsToRender().map(_0x5f3aa4 => _0x5f3aa4.section),
      sections_url: window.location.pathname
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: _0x52be56
    }).then(_0x25fe5c => _0x25fe5c.json()).then(_0x63825d => {
      this.classList.toggle("is-empty", _0x63825d.item_count === 0);
      this.getSectionsToRender().forEach(_0x53c82d => {
        const _0xe89b8f = document.getElementById(_0x53c82d.id).querySelector(_0x53c82d.selector) || document.getElementById(_0x53c82d.id);
        _0xe89b8f.innerHTML = this.getSectionInnerHTML(_0x63825d.sections[_0x53c82d.section], _0x53c82d.selector);
      });
    }).catch(_0x4a9add => {
      console.error(_0x4a9add);
    });
  }
  getSectionsToRender() {
    return [{
      id: "main-cart-items",
      section: document.getElementById("main-cart-items").dataset.id,
      selector: ".js-contents"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }, {
      id: "cart-live-region-text",
      section: "cart-live-region-text",
      selector: ".shopify-section"
    }, {
      id: "main-cart-footer",
      section: document.getElementById("main-cart-footer").dataset.id,
      selector: ".js-contents"
    }];
  }
  async updateQuantity(_0x13e1d6, _0x2b0f6c, _0xdaebda) {
    this.enableLoading(_0x13e1d6);
    const _0x5b64c9 = JSON.stringify({
      line: _0x13e1d6,
      quantity: _0x2b0f6c,
      sections: this.getSectionsToRender().map(_0x5b9e74 => _0x5b9e74.section),
      sections_url: window.location.pathname
    });
    try {
      const _0x47acf4 = await fetch("" + routes.cart_change_url, {
        ...fetchConfig(),
        ...{
          body: _0x5b64c9
        }
      });
      const _0x20bfe3 = await _0x47acf4.text();
      const _0x2c7c15 = JSON.parse(_0x20bfe3);
      const _0xc1722d = document.getElementById("Quantity-" + _0x13e1d6) || document.getElementById("Drawer-quantity-" + _0x13e1d6);
      const _0x3a3cdb = document.querySelectorAll(".cart-item");
      if (_0x2c7c15.errors) {
        _0xc1722d.value = _0xc1722d.getAttribute("value");
        this.updateLiveRegions(_0x13e1d6, _0x2c7c15.errors);
        return;
      }
      if (!_0x2c7c15.sections) {
        const _0x32bc69 = await fetch(routes.cart_url + "?sections=" + this.getSectionsToRender().map(_0x4e219c => _0x4e219c.section).join(","));
        _0x2c7c15.sections = await _0x32bc69.json();
      }
      this.classList.toggle("is-empty", _0x2c7c15.item_count === 0);
      const _0x5d3415 = document.querySelector("cart-drawer");
      const _0x5c229d = document.getElementById("main-cart-footer");
      if (_0x5c229d) {
        _0x5c229d.classList.toggle("is-empty", _0x2c7c15.item_count === 0);
      }
      if (_0x5d3415) {
        _0x5d3415.classList.toggle("is-empty", _0x2c7c15.item_count === 0);
      }
      this.getSectionsToRender().forEach(_0x2314d4 => {
        const _0x50c1dd = document.getElementById(_0x2314d4.id).querySelector(_0x2314d4.selector) || document.getElementById(_0x2314d4.id);
        _0x50c1dd.innerHTML = this.getSectionInnerHTML(_0x2c7c15.sections[_0x2314d4.section], _0x2314d4.selector);
      });
      const _0x2833b6 = _0x2c7c15.items[_0x13e1d6 - 1] ? _0x2c7c15.items[_0x13e1d6 - 1].quantity : undefined;
      let _0x456e62 = "";
      if (_0x3a3cdb.length === _0x2c7c15.items.length && _0x2833b6 !== parseInt(_0xc1722d.value)) {
        if (typeof _0x2833b6 === "undefined") {
          _0x456e62 = window.cartStrings.error;
        } else {
          _0x456e62 = window.cartStrings.quantityError.replace("[quantity]", _0x2833b6);
        }
      }
      this.updateLiveRegions(_0x13e1d6, _0x456e62);
      const _0x402657 = document.getElementById("CartItem-" + _0x13e1d6) || document.getElementById("CartDrawer-Item-" + _0x13e1d6);
      if (_0x402657 && _0x402657.querySelector("[name=\"" + _0xdaebda + "\"]")) {
        if (_0x5d3415) {
          trapFocus(_0x5d3415, _0x402657.querySelector("[name=\"" + _0xdaebda + "\"]"));
        } else {
          _0x402657.querySelector("[name=\"" + _0xdaebda + "\"]").focus();
        }
      } else if (_0x2c7c15.item_count === 0 && _0x5d3415) {
        trapFocus(_0x5d3415.querySelector(".drawer__inner-empty"), _0x5d3415.querySelector("a"));
      } else if (document.querySelector(".cart-item") && _0x5d3415) {
        trapFocus(_0x5d3415, document.querySelector(".cart-item__name"));
      }
      if (_0x5d3415) {
        _0x5d3415.checkForClear();
        const _0xddbc9a = _0x5d3415.querySelector("countdown-timer");
        if (_0xddbc9a) {
          _0xddbc9a.playTimer();
        }
        if (_0x5d3415.querySelector("cart-drawer-gift")) {
          _0x5d3415.checkForClear();
          let _0xd4fc8d = [];
          let _0x4465e8 = [];
          _0x5d3415.querySelectorAll("cart-drawer-gift").forEach(_0x2bcbcd => {
            if (_0x2bcbcd.getUpdateRequired()) {
              if (_0x5d3415.querySelector(".cart-item--product-" + _0x2bcbcd.dataset.handle)) {
                if (_0x2bcbcd.dataset.selected === "false") {
                  _0x4465e8.push(_0x2bcbcd);
                }
              } else if (_0x2bcbcd.dataset.selected === "true") {
                _0xd4fc8d.push(_0x2bcbcd);
              }
            }
          });
          if (_0x4465e8.length > 0) {
            _0x4465e8[0].removeFromCart();
          } else if (_0xd4fc8d.length > 0) {
            _0xd4fc8d[0].addToCart();
          }
        }
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      });
    } catch (_0xd9d3ec) {
      this.querySelectorAll(".loading-overlay").forEach(_0xeba568 => _0xeba568.classList.add("hidden"));
      const _0x37a11b = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      _0x37a11b.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(_0x13e1d6);
      if (this.secondCartItems && this.secondCartItems.updateCart) {
        this.secondCartItems.updateCart();
      }
      const _0x31e235 = new CustomEvent("cartQuantityUpdated", {
        detail: {
          handle: "handle"
        }
      });
      document.dispatchEvent(_0x31e235);
    }
  }
  updateLiveRegions(_0x46c1ca, _0x5c43d3) {
    const _0x4a42ca = document.getElementById("Line-item-error-" + _0x46c1ca) || document.getElementById("CartDrawer-LineItemErrork-" + _0x46c1ca);
    if (_0x4a42ca) {
      _0x4a42ca.querySelector(".cart-item__error-text").innerHTML = _0x5c43d3;
    }
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const _0x1e8f7e = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    _0x1e8f7e.setAttribute("aria-hidden", false);
    setTimeout(() => {
      _0x1e8f7e.setAttribute("aria-hidden", true);
    }, 1000);
  }
  getSectionInnerHTML(_0x4f5d94, _0x5219e9) {
    return new DOMParser().parseFromString(_0x4f5d94, "text/html").querySelector(_0x5219e9).innerHTML;
  }
  enableLoading(_0x44b8ba) {
    const _0x5254fa = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x5254fa.classList.add("cart__items--disabled");
    const _0x27cb71 = this.querySelectorAll("#CartItem-" + _0x44b8ba + " .loading-overlay");
    const _0x3c9eba = this.querySelectorAll("#CartDrawer-Item-" + _0x44b8ba + " .loading-overlay");
    [..._0x27cb71, ..._0x3c9eba].forEach(_0x33807d => _0x33807d.classList.remove("hidden"));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  disableLoading(_0x5c0b27) {
    const _0x24edaf = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x24edaf.classList.remove("cart__items--disabled");
    const _0x4546dd = this.querySelectorAll("#CartItem-" + _0x5c0b27 + " .loading-overlay");
    const _0xfff61a = this.querySelectorAll("#CartDrawer-Item-" + _0x5c0b27 + " .loading-overlay");
    _0x4546dd.forEach(_0x2ed6e5 => _0x2ed6e5.classList.add("hidden"));
    _0xfff61a.forEach(_0x508fa6 => _0x508fa6.classList.add("hidden"));
  }
  clearCart() {
    const _0x2aa945 = JSON.stringify({
      sections: this.getSectionsToRender().map(_0x3ba5d7 => _0x3ba5d7.section),
      sections_url: window.location.pathname
    });
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        body: _0x2aa945
      }
    }).then(_0x315645 => {
      return _0x315645.text();
    }).then(_0x1a008c => {
      const _0x1c8ff7 = JSON.parse(_0x1a008c);
      this.classList.add("is-empty");
      const _0x4692b5 = document.querySelector("cart-drawer");
      const _0x449554 = document.getElementById("main-cart-footer");
      if (_0x449554) {
        _0x449554.classList.add("is-empty");
      }
      if (_0x4692b5) {
        _0x4692b5.classList.add("is-empty");
      }
      this.getSectionsToRender().forEach(_0x1be398 => {
        const _0x188d89 = document.getElementById(_0x1be398.id).querySelector(_0x1be398.selector) || document.getElementById(_0x1be398.id);
        _0x188d89.innerHTML = this.getSectionInnerHTML(_0x1c8ff7.sections[_0x1be398.section], _0x1be398.selector);
      });
      if (_0x4692b5) {
        trapFocus(_0x4692b5.querySelector(".drawer__inner-empty"), _0x4692b5.querySelector("a"));
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      });
    }).catch(() => {
      this.querySelectorAll(".loading-overlay").forEach(_0x520be5 => _0x520be5.classList.add("hidden"));
      const _0x830366 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      _0x830366.textContent = window.cartStrings.error;
    });
  }
}
customElements.define("cart-items", CartItems);
function handleDiscountForm(_0x147233) {
  _0x147233.preventDefault();
  const _0xf894a = _0x147233.target.querySelector("[name=cart-discount-field]");
  const _0x34bcbc = _0x147233.target.querySelector(".cart-discount-form__error");
  const _0xb94328 = _0xf894a.value;
  if (_0xb94328 === undefined || _0xb94328.length === 0) {
    _0x34bcbc.style.display = "block";
    return;
  }
  _0x34bcbc.style.display = "none";
  const _0x8f20b7 = "/checkout?discount=";
  const _0x24d3c6 = _0x8f20b7 + _0xb94328;
  window.location.href = _0x24d3c6;
}
function handleDiscountFormChange(_0x1bded1) {
  const _0x24bab6 = document.querySelectorAll(".cart-discount-form__error");
  _0x24bab6.forEach(_0x138a10 => {
    _0x138a10.style.display = "none";
  });
}
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input[type=\"search\"]");
    this.resetButton = this.querySelector("button[type=\"reset\"]");
    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener("input", debounce(_0x4fd556 => {
        this.onChange(_0x4fd556);
      }, 300).bind(this));
    }
  }
  toggleResetButton() {
    const _0x1f78c6 = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && _0x1f78c6) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !_0x1f78c6) {
      this.resetButton.classList.add("hidden");
    }
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  onFormReset(_0x4abfe7) {
    _0x4abfe7.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const _0x31089b = this.getQuery();
    if (!this.searchTerm || !_0x31089b.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }
    this.updateSearchForTerm(this.searchTerm, _0x31089b);
    this.searchTerm = _0x31089b;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(_0x12b55d) {
    if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) {
      _0x12b55d.preventDefault();
    }
  }
  onFormReset(_0x3a7cea) {
    super.onFormReset(_0x3a7cea);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }
  onFocus() {
    const _0x506ba2 = this.getQuery();
    if (!_0x506ba2.length) {
      return;
    }
    if (this.searchTerm !== _0x506ba2) {
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }
  onKeyup(_0x5d9d3e) {
    if (!this.getQuery().length) {
      this.close(true);
    }
    _0x5d9d3e.preventDefault();
    switch (_0x5d9d3e.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(_0x578699) {
    if (_0x578699.code === "ArrowUp" || _0x578699.code === "ArrowDown") {
      _0x578699.preventDefault();
    }
  }
  updateSearchForTerm(_0x299a9e, _0x1b1036) {
    const _0x3d7072 = this.querySelector("[data-predictive-search-search-for-text]");
    const _0x32f310 = _0x3d7072?.innerText;
    if (_0x32f310) {
      if (_0x32f310.match(new RegExp(_0x299a9e, "g")).length > 1) {
        return;
      }
      const _0x5c107c = _0x32f310.replace(_0x299a9e, _0x1b1036);
      _0x3d7072.innerText = _0x5c107c;
    }
  }
  switchOption(_0x19dbc0) {
    if (!this.getAttribute("open")) {
      return;
    }
    const _0x1e9a4b = _0x19dbc0 === "up";
    const _0x515469 = this.querySelector("[aria-selected=\"true\"]");
    const _0x3ef8e8 = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(_0x4c2f35 => _0x4c2f35.offsetParent !== null);
    let _0xc85593 = 0;
    if (_0x1e9a4b && !_0x515469) {
      return;
    }
    let _0x1446ab = -1;
    let _0x47b2dd = 0;
    while (_0x1446ab === -1 && _0x47b2dd <= _0x3ef8e8.length) {
      if (_0x3ef8e8[_0x47b2dd] === _0x515469) {
        _0x1446ab = _0x47b2dd;
      }
      _0x47b2dd++;
    }
    this.statusElement.textContent = "";
    if (!_0x1e9a4b && _0x515469) {
      _0xc85593 = _0x1446ab === _0x3ef8e8.length - 1 ? 0 : _0x1446ab + 1;
    } else if (_0x1e9a4b) {
      _0xc85593 = _0x1446ab === 0 ? _0x3ef8e8.length - 1 : _0x1446ab - 1;
    }
    if (_0xc85593 === _0x1446ab) {
      return;
    }
    const _0x51eae4 = _0x3ef8e8[_0xc85593];
    _0x51eae4.setAttribute("aria-selected", true);
    if (_0x515469) {
      _0x515469.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", _0x51eae4.id);
  }
  selectOption() {
    const _0x4b4bb3 = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    if (_0x4b4bb3) {
      _0x4b4bb3.click();
    }
  }
  getSearchResults(_0x184862) {
    const _0x7b2c10 = _0x184862.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[_0x7b2c10]) {
      this.renderSearchResults(this.cachedResults[_0x7b2c10]);
      return;
    }
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(_0x184862) + "&section_id=predictive-search", {
      signal: this.abortController.signal
    }).then(_0x2704cb => {
      if (!_0x2704cb.ok) {
        var _0x2916fb = new Error(_0x2704cb.status);
        this.close();
        throw _0x2916fb;
      }
      return _0x2704cb.text();
    }).then(_0x4faf27 => {
      const _0x36dc1c = new DOMParser().parseFromString(_0x4faf27, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.allPredictiveSearchInstances.forEach(_0x3dace9 => {
        _0x3dace9.cachedResults[_0x7b2c10] = _0x36dc1c;
      });
      this.renderSearchResults(_0x36dc1c);
    }).catch(_0x5ea49c => {
      if (_0x5ea49c?.code === 20) {
        return;
      }
      this.close();
      throw _0x5ea49c;
    });
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }
  setLiveRegionText(_0x500886) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = _0x500886;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults(_0x2008a2) {
    this.predictiveSearchResults.innerHTML = _0x2008a2;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  getResultsMaxHeight() {
    const header = document.querySelector(".section-header, .wb-header");
    this.resultsMaxHeight = window.innerHeight - (header ? header.getBoundingClientRect().bottom : 0);
    return this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px";
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }
  close(_0x15e026 = false) {
    this.closeResults(_0x15e026);
    this.isOpen = false;
  }
  closeResults(_0x141fc9 = false) {
    if (_0x141fc9) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const _0x59b995 = this.querySelector("[aria-selected=\"true\"]");
    if (_0x59b995) {
      _0x59b995.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "data-defer";
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.checkForClear();
    this.addEventListener("keyup", _0x1dce99 => _0x1dce99.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const _0x2e26f8 = document.querySelector("#cart-icon-bubble");
    const _0xad4ae8 = _0x2e26f8.closest(".header__icons");
    _0x2e26f8.setAttribute("role", "button");
    _0x2e26f8.setAttribute("aria-haspopup", "dialog");
    _0x2e26f8.addEventListener("click", _0x153176 => {
      _0x153176.preventDefault();
      this.open(_0x2e26f8);
    });
    this.oseid = _0xad4ae8?.querySelector("form")?.dataset?.[this.dataset.type];
    _0x2e26f8.addEventListener("keydown", _0x3992ee => {
      if (_0x3992ee.code.toUpperCase() === "SPACE") {
        _0x3992ee.preventDefault();
        this.open(_0x2e26f8);
      }
    });
  }
  open(_0x513ad7) {
    if (_0x513ad7) {
      this.setActiveElement(_0x513ad7);
    }
    const _0x1e3160 = this.querySelector("[id^=\"Details-\"] summary");
    if (_0x1e3160 && !_0x1e3160.hasAttribute("role")) {
      this.setSummaryAccessibility(_0x1e3160);
    }
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener("transitionend", () => {
      const _0x519a09 = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
      const _0x5752e6 = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(_0x519a09, _0x5752e6);
    }, {
      once: true
    });
    document.body.classList.add("overflow-hidden");
    const _0x2e3bd7 = this.querySelector("countdown-timer");
    if (_0x2e3bd7) {
      _0x2e3bd7.playTimer();
    }
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const _0x53f9b3 = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
    const _0x1f5a33 = [];
    _0x53f9b3.forEach(_0x18629a => {
      if (_0x18629a.dataset.handle) {
        _0x1f5a33.push(_0x18629a.dataset.handle);
      }
    });
    return _0x1f5a33;
  }
  oneNonUpellRemaining() {
    const _0x4f38a4 = this.querySelectorAll(".cart-item");
    let _0x437c9c = 0;
    _0x4f38a4.forEach(_0x4eb7fd => {
      this.upsellHandles.forEach(_0x2e6482 => {
        if (_0x4eb7fd.classList.contains("cart-item--product-" + _0x2e6482)) {
          _0x437c9c++;
        }
      });
    });
    return _0x4f38a4.length - _0x437c9c <= 1;
  }
  checkForClear() {
    const _0x1dc82c = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach(_0x316e8f => {
      if (_0x1dc82c) {
        _0x316e8f.clearCart = true;
      } else {
        _0x316e8f.clearCart = false;
      }
    });
  }
  setSummaryAccessibility(_0xe25c0a) {
    _0xe25c0a.setAttribute("role", "button");
    _0xe25c0a.setAttribute("aria-expanded", "false");
    if (_0xe25c0a.nextElementSibling.getAttribute("id")) {
      _0xe25c0a.setAttribute("aria-controls", _0xe25c0a.nextElementSibling.id);
    }
    _0xe25c0a.addEventListener("click", _0x206154 => {
      _0x206154.currentTarget.setAttribute("aria-expanded", !_0x206154.currentTarget.closest("details").hasAttribute("open"));
    });
    _0xe25c0a.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(_0x315e84, _0x33e9df = false) {
    if (this.querySelector(".drawer__inner").classList.contains("is-empty")) {
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    }
    this.productId = _0x315e84.id;
    this.getSectionsToRender().forEach(_0x4527ab => {
      const _0x390755 = _0x4527ab.selector ? document.querySelector(_0x4527ab.selector) : document.getElementById(_0x4527ab.id);
      if (_0x390755) {
        _0x390755.innerHTML = this.getSectionInnerHTML(_0x315e84.sections[_0x4527ab.id], _0x4527ab.selector);
      }
    });
    this.checkForClear();
    const _0x31d4dd = this.querySelector("countdown-timer");
    if (_0x31d4dd && _0x31d4dd.playTimer) {
      _0x31d4dd.playTimer();
    }
    let _0x2bae07 = [];
    let _0x47eb76 = [];
    this.querySelectorAll("cart-drawer-gift").forEach(_0x16fe0c => {
      if (_0x16fe0c.getUpdateRequired()) {
        if (this.querySelector(".cart-item--product-" + _0x16fe0c.dataset.handle)) {
          if (_0x16fe0c.dataset.selected === "false") {
            _0x47eb76.push(_0x16fe0c);
          }
        } else if (_0x16fe0c.dataset.selected === "true") {
          _0x2bae07.push(_0x16fe0c);
        }
      }
    });
    if (_0x47eb76.length > 0) {
      _0x47eb76[0].removeFromCart();
    } else if (_0x2bae07.length > 0) {
      _0x2bae07[0].addToCart();
    }
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (_0x33e9df) {
        return;
      }
      this.open();
    });
  }
  getSectionInnerHTML(_0x501dc5, _0x273db9 = ".shopify-section") {
    let _0x45c79a = new DOMParser().parseFromString(_0x501dc5, "text/html").querySelector(_0x273db9);
    if (_0x273db9 === "#CartDrawer") {
      fixParsedHtml(this, _0x45c79a);
    }
    let _0xb7d629 = _0x45c79a.innerHTML;
    return _0xb7d629;
  }
  getSectionsToRender() {
    return [{
      id: "cart-drawer",
      selector: "#CartDrawer"
    }, {
      id: "cart-icon-bubble"
    }];
  }
  getSectionDOM(_0x49181c, _0x5234d6 = ".shopify-section") {
    return new DOMParser().parseFromString(_0x49181c, "text/html").querySelector(_0x5234d6);
  }
  setActiveElement(_0x499cec) {
    this.activeElement = _0x499cec;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname
      })
    }).then(_0x338c03 => _0x338c03.json()).then(_0x27589e => {
      document.querySelector("cart-drawer").renderContents(_0x27589e, true);
    }).catch(_0x2f5368 => {
      console.error(_0x2f5368);
    });
  }
  getSectionInnerHTML(_0x4f588e, _0x48c713) {
    let _0x73bbea = new DOMParser().parseFromString(_0x4f588e, "text/html").querySelector(_0x48c713);
    if (_0x48c713 === ".drawer__inner") {
      fixParsedHtml(this.cartDrawer, _0x73bbea);
    }
    let _0x5202ac = _0x73bbea.innerHTML;
    return _0x5202ac;
  }
  getSectionsToRender() {
    return [{
      id: "CartDrawer",
      section: "cart-drawer",
      selector: ".drawer__inner"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(_0x59c9f5, _0x3d094a) {
  const _0x141755 = _0x3d094a.querySelector(".cart-timer");
  if (_0x141755) {
    oldTimer = _0x59c9f5.querySelector(".cart-timer");
    if (oldTimer) {
      _0x141755.innerHTML = oldTimer.innerHTML;
    }
  }
  const _0x5cf940 = _0x59c9f5.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  let _0x4f4910 = _0x3d094a.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  _0x5cf940.forEach((_0x273be7, _0x834dbb) => {
    if (_0x273be7.nodeName.toLowerCase() === "cart-drawer-upsell") {
      _0x4f4910[_0x834dbb].dataset.selected = _0x273be7.dataset.selected;
    }
    _0x4f4910[_0x834dbb].dataset.id = _0x273be7.dataset.id;
    _0x4f4910[_0x834dbb].querySelector("[name=\"id\"]").value = _0x273be7.querySelector("[name=\"id\"]").value;
    if (_0x4f4910[_0x834dbb].querySelector(".upsell__image__img")) {
      _0x4f4910[_0x834dbb].querySelector(".upsell__image__img").src = _0x273be7.querySelector(".upsell__image__img").src;
    }
    if (_0x4f4910[_0x834dbb].querySelector(".upsell__variant-picker")) {
      const _0x10eea5 = _0x273be7.querySelectorAll(".select__select");
      _0x4f4910[_0x834dbb].querySelectorAll(".select__select").forEach((_0x484345, _0x2472b5) => {
        _0x484345.value = _0x10eea5[_0x2472b5].value;
        _0x484345.querySelectorAll("option").forEach(_0x9d8b52 => {
          _0x9d8b52.removeAttribute("selected");
          if (_0x9d8b52.value === _0x10eea5[_0x2472b5].value.trim()) {
            _0x9d8b52.setAttribute("selected", "");
          }
        });
      });
    }
    if (_0x273be7.dataset.updatePrices === "true") {
      var _0x23af72 = _0x4f4910[_0x834dbb].querySelector(".upsell__price");
      var _0x11ffbb = _0x273be7.querySelector(".upsell__price");
      if (_0x23af72 && _0x11ffbb) {
        _0x23af72.innerHTML = _0x11ffbb.innerHTML;
      }
    }
  });
}
if (!customElements.get("product-info")) {
  customElements.define("product-info", class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.deferredMedia = document.querySelector("[" + defMed + "]");
      this.input = this.querySelector(".quantity__input");
      this.currentVariant = this.querySelector(".product-variant-id");
      this.variantSelects = this.querySelector("variant-radios");
      this.submitButton = this.querySelector("[type=\"submit\"]");
      this.form = this.querySelector("#ProductForm-" + this.dataset.section);
      this.hasUrl = this.dataset.url !== null;
    }
    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;
    connectedCallback() {
      if (!this.input) {
        return;
      }
      this.quantityForm = this.querySelector(".product-form__quantity");
      if (!this.quantityForm) {
        return;
      }
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, _0x45cab8 => {
        const _0x1e98d0 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (_0x45cab8.data.sectionId !== _0x1e98d0) {
          return;
        }
        this.updateQuantityRules(_0x45cab8.data.sectionId, _0x45cab8.data.html);
        this.setQuantityBoundries();
      });
      if (!this.form) {
        return;
      }
      if (!this.deferredMedia || !this.deferredMedia.src || !this.deferredMedia.src.includes("net")) {
        this.form.ref = true;
      }
    }
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }
    setQuantityBoundries() {
      const _0x2912d3 = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      };
      let _0x2bdf65 = _0x2912d3.min;
      const _0x4ae596 = _0x2912d3.max === null ? _0x2912d3.max : _0x2912d3.max - _0x2912d3.cartQuantity;
      if (_0x4ae596 !== null) {
        _0x2bdf65 = Math.min(_0x2bdf65, _0x4ae596);
      }
      if (_0x2912d3.cartQuantity >= _0x2912d3.min) {
        _0x2bdf65 = Math.min(_0x2bdf65, _0x2912d3.step);
      }
      this.input.min = _0x2bdf65;
      this.input.max = _0x4ae596;
      this.input.value = _0x2bdf65;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }
    initShareLinks() {
      const _0x554361 = this.querySelector(".share-url-button");
      if (!_0x554361) {
        this.shareUrl = true;
      }
    }
    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) {
        return;
      }
      this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
      fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(_0x15a623 => {
        return _0x15a623.text();
      }).then(_0x1fd315 => {
        const _0x33b25b = new DOMParser().parseFromString(_0x1fd315, "text/html");
        this.updateQuantityRules(this.dataset.section, _0x33b25b);
        this.setQuantityBoundries();
      }).catch(_0x3235bf => {
        console.error(_0x3235bf);
      }).finally(() => {
        this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
      });
    }
    updateQuantityRules(_0x89c27, _0x27b16a) {
      const _0x301355 = _0x27b16a.getElementById("Quantity-Form-" + _0x89c27);
      const _0x48e714 = [".quantity__input", ".quantity__rules", ".quantity__label"];
      for (let _0x184cc7 of _0x48e714) {
        const _0x26ed4e = this.quantityForm.querySelector(_0x184cc7);
        const _0x17adf4 = _0x301355.querySelector(_0x184cc7);
        if (!_0x26ed4e || !_0x17adf4) {
          continue;
        }
        if (_0x184cc7 === ".quantity__input") {
          const _0x4cc16c = ["data-cart-quantity", "data-min", "data-max", "step"];
          for (let _0x1fb087 of _0x4cc16c) {
            const _0x3e363b = _0x17adf4.getAttribute(_0x1fb087);
            if (_0x3e363b !== null) {
              _0x26ed4e.setAttribute(_0x1fb087, _0x3e363b);
            }
          }
        } else {
          _0x26ed4e.innerHTML = _0x17adf4.innerHTML;
        }
      }
    }
  });
}
;
function getFocusableElements(_0x3fed8e) {
  return Array.from(_0x3fed8e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(_0x12f7c3 => {
  _0x12f7c3.setAttribute("role", "button");
  _0x12f7c3.setAttribute("aria-expanded", _0x12f7c3.parentNode.hasAttribute("open"));
  if (_0x12f7c3.nextElementSibling.getAttribute("id")) {
    _0x12f7c3.setAttribute("aria-controls", _0x12f7c3.nextElementSibling.id);
  }
  _0x12f7c3.addEventListener("click", _0x561332 => {
    _0x561332.currentTarget.setAttribute("aria-expanded", !_0x561332.currentTarget.closest("details").hasAttribute("open"));
  });
  if (_0x12f7c3.closest("header-drawer")) {
    return;
  }
  _0x12f7c3.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(_0x48d0b0, _0x4bf7be = _0x48d0b0) {
  var _0x49e26c = getFocusableElements(_0x48d0b0);
  var _0x27c9c7 = _0x49e26c[0];
  var _0x20cb68 = _0x49e26c[_0x49e26c.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = _0x1fdba1 => {
    if (_0x1fdba1.target !== _0x48d0b0 && _0x1fdba1.target !== _0x20cb68 && _0x1fdba1.target !== _0x27c9c7) {
      return;
    }
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (_0x34abf9) {
    if (_0x34abf9.code.toUpperCase() !== "TAB") {
      return;
    }
    if (_0x34abf9.target === _0x20cb68 && !_0x34abf9.shiftKey) {
      _0x34abf9.preventDefault();
      _0x27c9c7.focus();
    }
    if ((_0x34abf9.target === _0x48d0b0 || _0x34abf9.target === _0x27c9c7) && _0x34abf9.shiftKey) {
      _0x34abf9.preventDefault();
      _0x20cb68.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  _0x4bf7be.focus();
  if (_0x4bf7be.tagName === "INPUT" && ["search", "text", "email", "url"].includes(_0x4bf7be.type) && _0x4bf7be.value) {
    _0x4bf7be.setSelectionRange(0, _0x4bf7be.value.length);
  }
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(_0x4d48f4 => {
    _0x4d48f4.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
  });
  document.querySelectorAll(".js-vimeo").forEach(_0x4dd8e8 => {
    _0x4dd8e8.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
  });
  document.querySelectorAll("media-gallery template video").forEach(_0x24109c => _0x24109c.pause());
  document.querySelectorAll("product-model").forEach(_0x182509 => {
    if (_0x182509.modelViewerUI) {
      _0x182509.modelViewerUI.pause();
    }
  });
}
function removeTrapFocus(_0x639c47 = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (_0x639c47) {
    _0x639c47.focus();
  }
}
function onKeyUpEscape(_0x4aee82) {
  if (_0x4aee82.code.toUpperCase() !== "ESCAPE") {
    return;
  }
  const _0x384cc1 = _0x4aee82.target.closest("details[open]");
  if (!_0x384cc1) {
    return;
  }
  const _0x15cea8 = _0x384cc1.querySelector("summary");
  _0x384cc1.removeAttribute("open");
  _0x15cea8.setAttribute("aria-expanded", false);
  _0x15cea8.focus();
}
function debounce(_0x5d8b96, _0x2bcdae) {
  let _0x4d59eb;
  return (..._0x59c48a) => {
    clearTimeout(_0x4d59eb);
    _0x4d59eb = setTimeout(() => _0x5d8b96.apply(this, _0x59c48a), _0x2bcdae);
  };
}
function fetchConfig(_0x4862ea = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + _0x4862ea
    }
  };
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (_0x385cc5, _0x3c248e) {
  return function () {
    return _0x385cc5.apply(_0x3c248e, arguments);
  };
};
Shopify.setSelectorByValue = function (_0x34d992, _0x43f82f) {
  for (var _0x183745 = 0, _0x5bc4e7 = _0x34d992.options.length; _0x183745 < _0x5bc4e7; _0x183745++) {
    var _0x3b0252 = _0x34d992.options[_0x183745];
    if (_0x43f82f == _0x3b0252.value || _0x43f82f == _0x3b0252.innerHTML) {
      _0x34d992.selectedIndex = _0x183745;
      return _0x183745;
    }
  }
};
Shopify.addListener = function (_0x582fd6, _0x19bc62, _0x4d3d6c) {
  if (_0x582fd6.addEventListener) {
    _0x582fd6.addEventListener(_0x19bc62, _0x4d3d6c, false);
  } else {
    _0x582fd6.attachEvent("on" + _0x19bc62, _0x4d3d6c);
  }
};
Shopify.postLink = function (_0x54184e, _0x2e4c25) {
  _0x2e4c25 = _0x2e4c25 || {};
  var _0x4c86d5 = _0x2e4c25.method || "post";
  var _0x2e6889 = _0x2e4c25.parameters || {};
  var _0x5ab5f0 = document.createElement("form");
  _0x5ab5f0.setAttribute("method", _0x4c86d5);
  _0x5ab5f0.setAttribute("action", _0x54184e);
  for (var _0xe8510 in _0x2e6889) {
    var _0x226157 = document.createElement("input");
    _0x226157.setAttribute("type", "hidden");
    _0x226157.setAttribute("name", _0xe8510);
    _0x226157.setAttribute("value", _0x2e6889[_0xe8510]);
    _0x5ab5f0.appendChild(_0x226157);
  }
  document.body.appendChild(_0x5ab5f0);
  _0x5ab5f0.submit();
  document.body.removeChild(_0x5ab5f0);
};
Shopify.internationalAccessAccept = function () {
  return true;
};
Shopify.CountryProvinceSelector = function (_0x262392, _0x3b01e5, _0x3f2b6d) {
  this.countryEl = document.getElementById(_0x262392);
  this.provinceEl = document.getElementById(_0x3b01e5);
  this.provinceContainer = document.getElementById(_0x3f2b6d.hideElement || _0x3b01e5);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var _0x3a9514 = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, _0x3a9514);
    this.countryHandler();
  },
  initProvince: function () {
    var _0x200aeb = this.provinceEl.getAttribute("data-default");
    if (_0x200aeb && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, _0x200aeb);
    }
  },
  countryHandler: function (_0x3cddec) {
    var _0x367422 = this.countryEl.options[this.countryEl.selectedIndex];
    var _0x49360a = _0x367422.getAttribute("data-provinces");
    var _0x34d722 = JSON.parse(_0x49360a);
    this.clearOptions(this.provinceEl);
    if (_0x34d722 && _0x34d722.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var _0x1298bf = 0; _0x1298bf < _0x34d722.length; _0x1298bf++) {
        var _0x367422 = document.createElement("option");
        _0x367422.value = _0x34d722[_0x1298bf][0];
        _0x367422.innerHTML = _0x34d722[_0x1298bf][1];
        this.provinceEl.appendChild(_0x367422);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (_0x548ed9) {
    while (_0x548ed9.firstChild) {
      _0x548ed9.removeChild(_0x548ed9.firstChild);
    }
  },
  setOptions: function (_0x546303, _0x57c6b8) {
    for (var _0x55054d = 0, _0x29d1d8 = _0x57c6b8.length; _0x55054d < _0x57c6b8.length; _0x55054d++) {
      var _0x47d8d3 = document.createElement("option");
      _0x47d8d3.value = _0x57c6b8[_0x55054d];
      _0x47d8d3.innerHTML = _0x57c6b8[_0x55054d];
      _0x546303.appendChild(_0x47d8d3);
    }
  }
};
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.isAfterScroll = this.dataset.afterScroll === "true";
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section);
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    if (this.isAfterScroll) {
      if (this.mainAtcBtn) {
        this.checkATCScroll();
        document.addEventListener("scroll", this.checkATCScroll.bind(this));
      }
    } else {
      this.floatingBtns.forEach(_0x278fc6 => {
        _0x278fc6.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      });
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
      }
    }
  }
  checkATCScroll() {
    if (window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight) {
      this.style.transform = "none";
      this.scrolledPast = true;
    } else {
      this.style.transform = "";
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach(_0x3a749a => {
      if (this.scrolledPast) {
        _0x3a749a.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      } else {
        _0x3a749a.style.setProperty("--sticky-atc-offset", "0px");
      }
    });
  }
  handleScrollBtn() {
    const _0x1b9f9f = document.querySelector("sticky-header");
    const _0x4f9952 = _0x1b9f9f ? _0x1b9f9f.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - _0x4f9952 - 15,
      behavior: "smooth"
    });
  }
  footerSpacing() {
    let _0x14c30a = document.querySelector(".sticky-atc-footer-spacer");
    if (_0x14c30a) {
      return;
    }
    _0x14c30a = document.createElement("div");
    _0x14c30a.className = "sticky-atc-footer-spacer";
    _0x14c30a.style.height = this.clientHeight - 1 + "px";
    _0x14c30a.style.display = "block";
    const _0x162652 = document.querySelector(".footer");
    if (_0x162652) {
      _0x14c30a.style.background = window.getComputedStyle(_0x162652).background;
    }
    document.body.appendChild(_0x14c30a);
  }
}
customElements.define("sticky-atc", StickyAtc);
